import React, { useEffect, useState } from "react";
import { Button, Table } from "react-bootstrap";
import { withTranslation } from "react-i18next";
import {
	BiChevronDown,
	BiChevronUp,
	BiChevronsRight,
	BiLink
} from "react-icons/bi";
import { LS_AUTHORITY_KEY, USER_ROLE } from "../../../core/constants/common";
import RiskConfigService from "../../../core/service/RiskConfigService";
import "./StandardTemplate.scss";
import { toast } from "react-toastify";

function StdTemplateDSLinkingPane({ t, 
	params, 
	standardId,
	onClose,
	onSaveCallback
}) {

  const authority = JSON.parse(localStorage.getItem(LS_AUTHORITY_KEY));
	const [assessments, setAssessments] = useState([]);
	const [data, setData] = useState([]);	
	const [dsVisibility, setDSVisibility] = useState({});

	useEffect(() => {
		getDataSourceByStandard();
	}, []);

	const getDataSourceByStandard = (parentId = '', level = '') => {
    RiskConfigService.getDataSourceByRegulation(standardId, parentId, 'KPI', true, authority.roles.includes(USER_ROLE.SUPER_ADMIN))
      .then(res => {
				if (res.status !== 200) return;

				if (parentId > 0 && level >= 0) {
					let d = JSON.parse(JSON.stringify(data));
					iterateDatasourceAndUpdateChildren({	
						currentLevel: 0,						
						levelToUpdate: level, 
						parentId: parentId,
						dataClone: d,
						childrenToUpdate: res.data,							
					});
					setData(d);
				} else {
					setAssessments(res.data ?? []);    
				}   
      }).catch((error) => {
      });
  };

  const iterateDatasourceAndUpdateChildren = ({
  	currentLevel, levelToUpdate, parentId, dataClone, childrenToUpdate
  }) => {
  	dataClone?.forEach(d => {
  		if (currentLevel === levelToUpdate) {
  			if (d.id !== parentId) return;

  			d.children = childrenToUpdate;
  		} else if (d.children?.length > 0) {
  			iterateDatasourceAndUpdateChildren({
  				currentLevel: currentLevel + 1, 
  				levelToUpdate: levelToUpdate,
  				parentId: parentId,
  				dataClone: d.children,
  				childrenToUpdate: childrenToUpdate
  			});
  		}
  	});
  };

	const onAssessmentChange = (id) => {
		RiskConfigService.getDataSourceByRegulation(standardId, assessments[0].id, 'KPI', true, authority.roles.includes(USER_ROLE.SUPER_ADMIN))
		.then(res => {
			if (res.status !== 200) return;

			setData(res.data.find(d => d.id === id)?.children ?? []);
		}).catch((error) => {
		});
	};

	const renderDataSourceTypeSelector = () => {
		return (
			<div className="mb-2">
				<p className="mb-2">{t('SelectDatasource.label')}</p>
				<div className="SelectDataSource_box">
					<ul>
						<li>
							<input type="radio" className="btn-check" name="options" id="option1" autocomplete="off" />
							<label className="btn-selectData" for="option1">{t('Assessment.label')}</label>
						</li>
						<li>
							<input type="radio" className="btn-check" name="options" id="option2" autocomplete="off" />
							<label className="btn-selectData" for="option2">{t('Document.label')}</label>
						</li>
						<li>
							<input type="radio" className="btn-check" name="options" id="option3" autocomplete="off" />
							<label className="btn-selectData" for="option3">{t('ExternalDevice.label')}</label>
						</li>
					</ul>
				</div>
			</div>
		);
	};

	const renderAssessmentSelector = () => {
		return (
			<div className="mb-2">
					<p className="mb-2">{t('SelectAssessment.label')}</p>
					<select className="form-select" onChange={(e) => onAssessmentChange(+e.target.value)}>
					<option value=''>Select</option>
					{ 
						assessments?.length > 0 && 
						assessments[0].children?.map(a => {
							return <option key={a.id} value={a.id}>{a.name}</option>
						})
					}
					</select>
				</div>
		);
	};

	const toggleVisibility = (level, datasource) => {
		const vis = JSON.parse(JSON.stringify(dsVisibility));
		if (!vis[level]) {
			vis[level] = {};
			vis[level][datasource.id] = true;
			getDataSourceByStandard(datasource.id, level);
		} else {
			const val = vis[level][datasource.id] === true ? false : true;
			vis[level][datasource.id] = val;
			if (val) {
				getDataSourceByStandard(datasource.id, level);
			}
		}
		setDSVisibility(vis);
	};

	const renderDatasources = (level = 0, datasources) => {
		const rowClass = level === 0 
			? 'Link_topic-row' :  level === 1 
			? 'Link_Mainsub-row' : 'Link_sub-row';
		return (		
			<>
			{
				datasources.map((d, dIndex) => {
					return (
						<>
							<tr key={`formRow-${d.id}-${d.Index}`} className={rowClass}>
								<td>
									{
										d.dataSourceType !== 'FIELD' &&
										<div 
											className="icon_svg cursor" 
											onClick={() => toggleVisibility(level, d)}>
											{(!dsVisibility[level] || !dsVisibility[level][d.id]) && <BiChevronDown />}
											{dsVisibility[level] && dsVisibility[level][d.id] === true && <BiChevronUp />}
										</div>
									}
									
									<span className={params.dataSource?.dataSourceType === d.dataSourceType && 
										params.dataSource?.id === d.id ? 'fw-bold' : ''}>{d.name}</span>
								</td>
								<td>
									{ 
										params.dataSource?.dataSourceType === d.dataSourceType && 
										params.dataSource?.id === d.id
										? <BiLink className={'text-success'}/>
										: <BiLink className='text-primary cursor' onClick={() => linkDataSource(d)}/>
									}
									
								</td>
							</tr>
							{
								d.children?.length > 0 && 
								dsVisibility[level] &&
								dsVisibility[level][d.id] === true &&
								renderDatasources(level + 1, d.children)
							}
						</>
					)
				})
			}
			</>
		);
	};

	const linkDataSource = (ds) => {
		const paramId = params.paramType === 'metric' ? params.metricId : params.dpId;
		RiskConfigService.saveDataSourceByRegulation(
			standardId, paramId, ds.id, params.paramType, true
		).then(res => {
			if (res.status !== 200) return;

			toast.success("Success", {
				position: toast.POSITION.TOP_RIGHT,
			});
			onSaveCallback();
		}).catch(er => {});
	} 	

	return (
		<div className="card DataSource_card">
			<div className="DataSource_card_head">
				<h6>{t('Linktodatasource.label')}</h6>
				<Button variant="secondary" size="sm" onClick={() => onClose()}>{t('Close.label')}</Button>
			</div>
			<div className="DataSource_card_body">
				{renderDataSourceTypeSelector()}
				{renderAssessmentSelector()}
				<div className="mb-2">
					<p className="mb-2">{t('LinkToAssessment.label')}</p>
					<div className="card Link_assessment_card">
					<Table>
						<tbody>
							{renderDatasources(0, data)}		
						</tbody>
					</Table>				
					</div>
					<div className="p-2">
						<i className="text-primary">Energy <BiChevronsRight /> Electricity consumed which is generated from oraganiztions' own non-renewable power generation <BiChevronsRight /> Electricity generated from Nuclear reaction</i>
					</div>
				</div>
			</div>
		</div>
	);
}
export default withTranslation()(StdTemplateDSLinkingPane);
